<template>
  <div>
    <button class="icon-button" :title="titleText" @click="addNote">
      <img
        v-if="!item.lotNoteData"
        src="@/assets/img/icons/add-note.svg"
        alt="Добавить заметку"
      />
      <img v-else src="@/assets/img/icons/note.svg" alt="Добавить заметку" />
    </button>
    <modal-window :show="showNote" @close="showNote = false">
      <template v-slot:popup-title
        >Заметка к лоту №: {{ item.contractNumber }} <br />
        {{ item.car.name }}
      </template>
      <template v-slot:popup-content>
        <div class="d-flex flex-column">
          <div v-if="!editNote && item.lotNoteData" class="note-content">
            {{ item.lotNoteData.text }}
          </div>
          <div v-else class="form-field note-textarea">
            <textarea
              v-model="note"
              class="input"
              placeholder="Введите заметку"
              rows="6"
              :maxlength="245"
            ></textarea>
            <span class="note-length">{{ note.length }}/245</span>
            <p v-if="noteError" class="form-error">
              {{ noteError }}
            </p>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <button
            v-if="!editNote"
            type="button"
            class="button"
            @click="toEditNote"
          >
            Редактировать
          </button>
          <template v-else>
            <div
              class="text-center position-relative"
              :class="{ '--loading': isNoteSaving }"
            >
              <button class="button" @click="saveNote">Сохранить</button>
              <Preloader v-if="isNoteSaving" class="for-button" invert />
            </div>
            <button
              type="button"
              class="button button--transparent ms-4"
              @click="showNote = false"
            >
              Отменить
            </button>
          </template>
        </div>
      </template>
    </modal-window>
  </div>
</template>

<script setup lang="ts">
import ModalWindow from "~/components/page/modalWindow.vue";
import Preloader from "~/components/page/Preloader.vue";

const props = defineProps<{
  item: any;
}>();

const showNote = ref(false);
const note = ref("");
const noteError = ref("");
const isNoteSaving = ref(false);
const editNote = ref(false);

const titleText = toRef(() =>
  props.item.lotNoteData
    ? `${props.item.lotNoteData.text}`
    : "Заметка покупателя",
);

const toEditNote = () => {
  editNote.value = true;
  note.value = props.item.lotNoteData?.text || "";
};

const addNote = () => {
  showNote.value = true;
  if (props.item.lotNoteData) {
    editNote.value = false;
  } else {
    toEditNote();
  }
};

const saveNote = async () => {
  noteError.value = "";
  note.value = note.value.trim();
  if (!note.value.length) {
    noteError.value = "Введите заметку";
    return;
  }

  if (note.value.length > 245) {
    noteError.value = "Заметка не должна превышать 245 символов";
    return;
  }

  const url = props.item.lotNoteData ? "lot-notes/update" : "lot-notes/create";

  const data = props.item.lotNoteData
    ? {
        lotNoteId: props.item.lotNoteData.lotNoteId,
        text: note.value,
      }
    : {
        lotId: props.item.id,
        text: note.value,
      };

  const apiRequest = new ApiRequest("post", url, null, data);
  isNoteSaving.value = true;

  await apiRequest.request();

  editNote.value = false;
  isNoteSaving.value = false;
  props.item.lotNoteData = {
    lotNoteId: Math.random().toString(36).substring(2, 15),
    text: note.value,
  };
};
</script>

<style scoped>
button {
  cursor: pointer;
}
.note-content {
  margin-top: 68px;
  margin-bottom: 100px;

  font-size: 14px;
  text-align: center;
  white-space: pre-wrap;
  word-break: break-word;
}

.note-textarea {
  margin: 25px 0 55px;

  textarea {
    word-break: break-word;
  }
}

.note-length {
  font-size: 12px;
  color: #999;
  text-align: right;
  margin-top: 2px;
}
</style>
